import { render, staticRenderFns } from "./Volume.vue?vue&type=template&id=9ffdc8d0"
import script from "./Volume.vue?vue&type=script&lang=js"
export * from "./Volume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports